import { useState } from 'react'
import { router } from '@inertiajs/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faBars, faChevronDown, faRightFromBracket,
  faCrown, faGear, faMagnifyingGlass
} from '@fortawesome/free-solid-svg-icons'
import NotificationBell from '../NotificationBell'

export default function SuperadminTopbar({ current_user, onMenuToggle, placeholder, children }) {
  const [profileOpen, setProfileOpen] = useState(false)
  const logout = () => { if (confirm('Yakin ingin keluar?')) router.delete('/logout') }

  return (
    <header className="h-16 bg-gray-900 border-b border-gray-800 flex items-center px-4 lg:px-6 gap-4 flex-shrink-0">
      <button className="lg:hidden text-gray-500 hover:text-gray-300" onClick={onMenuToggle}>
        <FontAwesomeIcon icon={faBars} className="w-5 h-5" />
      </button>

      {children ?? (placeholder && (
        <div className="flex-1 max-w-md">
          <div className="relative">
            <FontAwesomeIcon icon={faMagnifyingGlass} className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" />
            <input
              type="text"
              placeholder={placeholder}
              className="w-full pl-9 pr-4 py-2 text-sm bg-gray-800 border border-gray-700 text-gray-300 placeholder-gray-600 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all"
            />
          </div>
        </div>
      ))}

      <div className="ml-auto flex items-center gap-3">
        <NotificationBell href="/superadmin/notifications" className="hover:bg-gray-800 text-gray-400" badgeClass="bg-indigo-500" />
        <div className="relative">
          <button
            onClick={() => setProfileOpen(!profileOpen)}
            className="flex items-center gap-2 px-3 py-1.5 rounded-lg hover:bg-gray-800 transition-colors"
          >
            <div className="w-7 h-7 rounded-full bg-indigo-900/60 ring-1 ring-indigo-600/40 flex items-center justify-center">
              <FontAwesomeIcon icon={faCrown} className="w-3.5 h-3.5 text-indigo-400" />
            </div>
            <span className="text-sm font-medium text-gray-300 hidden sm:block">{current_user?.name || 'Superadmin'}</span>
            <FontAwesomeIcon icon={faChevronDown} className="w-3 h-3 text-gray-500" />
          </button>
          {profileOpen && (
            <div className="absolute right-0 top-full mt-1 w-48 bg-gray-800 rounded-xl shadow-2xl border border-gray-700 py-1 z-50">
              <div className="px-3 py-2 border-b border-gray-700">
                <div className="text-xs font-semibold text-gray-200">{current_user?.name}</div>
                <div className="text-[11px] text-gray-500 truncate">{current_user?.email}</div>
              </div>
              <a href="/superadmin/settings" className="flex items-center gap-2 px-3 py-2 text-sm text-gray-300 hover:bg-gray-700">
                <FontAwesomeIcon icon={faGear} className="w-3.5 h-3.5" /> Pengaturan
              </a>
              <button onClick={logout} className="w-full flex items-center gap-2 px-3 py-2 text-sm text-red-400 hover:bg-red-900/20">
                <FontAwesomeIcon icon={faRightFromBracket} className="w-3.5 h-3.5" /> Keluar
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  )
}
